// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customer-table-container {
  --table-bg-color: #fff;
  --table-border-color: var(--cui-border-color, #d8dbe0);
  --table-text-color: var(--cui-body-color, #4f5d73);
  --filter-bg-color: #f8f9fa;
  --filter-border-color: #dee2e6;
  --filter-focus-color: var(--cui-primary, #0d6efd);
}
html[data-coreui-theme=dark] .customer-table-container {
  --table-bg-color: var(--cui-dark-bg-subtle, #1e1e2f);
  --table-border-color: var(--cui-dark-border-subtle, #333);
  --table-text-color: var(--cui-body-color, #fff);
  --filter-bg-color: #2a2d3a;
  --filter-border-color: #404552;
  --filter-focus-color: var(--cui-primary, #0d6efd);
}
.customer-table-container .table {
  border-color: var(--table-border-color) !important;
  margin-bottom: 0;
}
.customer-table-container .table,
.customer-table-container .table thead,
.customer-table-container .table tbody,
.customer-table-container .table tr,
.customer-table-container .table th,
.customer-table-container .table td {
  border-color: var(--table-border-color) !important;
}
.customer-table-container .table:hover,
.customer-table-container .table thead:hover,
.customer-table-container .table tbody:hover,
.customer-table-container .table tr:hover,
.customer-table-container .table th:hover,
.customer-table-container .table td:hover {
  border-color: var(--table-border-color) !important;
}
.customer-table-container .card {
  border-color: var(--table-border-color) !important;
  background-color: var(--table-bg-color);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.customer-table-container .card:hover {
  border-color: var(--table-border-color) !important;
}
.customer-table-container .card .card-body {
  background-color: var(--table-bg-color);
  color: var(--table-text-color);
}
.customer-table-container .filter-controls .filter-toggle-btn {
  position: relative;
  transition: all 0.3s ease;
}
.customer-table-container .filter-controls .filter-toggle-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}
.customer-table-container .filter-controls .filter-toggle-btn .filter-count-badge {
  background-color: #dc3545;
  color: white;
  border-radius: 50%;
  padding: 2px 6px;
  font-size: 0.75rem;
  font-weight: 600;
  min-width: 18px;
  text-align: center;
  display: inline-block;
  animation: pulse 2s infinite;
}
.customer-table-container .filter-controls .clear-filters-btn {
  transition: all 0.2s ease;
}
.customer-table-container .filter-controls .clear-filters-btn:hover {
  color: #dc3545;
  border-color: #dc3545;
}
.customer-table-container .filter-controls .results-info .filtered-info {
  color: var(--cui-secondary);
  font-style: italic;
}
.customer-table-container .filter-panel {
  background-color: var(--filter-bg-color);
  border: 1px solid var(--filter-border-color);
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.05);
}
.customer-table-container .filter-panel .filter-field .filter-label {
  display: block;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--table-text-color);
  margin-bottom: 0.5rem;
}
.customer-table-container .filter-panel .filter-field .filter-input-wrapper {
  position: relative;
}
.customer-table-container .filter-panel .filter-field .filter-input-wrapper .filter-input-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--cui-secondary);
  z-index: 5;
  pointer-events: none;
}
.customer-table-container .filter-panel .filter-field .filter-input-wrapper .filter-input {
  padding-left: 35px;
  padding-right: 35px;
  border: 1px solid var(--filter-border-color);
  background-color: var(--table-bg-color);
  color: var(--table-text-color);
  transition: all 0.2s ease;
}
.customer-table-container .filter-panel .filter-field .filter-input-wrapper .filter-input:focus {
  border-color: var(--filter-focus-color);
  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);
  background-color: var(--table-bg-color);
  color: var(--table-text-color);
}
.customer-table-container .filter-panel .filter-field .filter-input-wrapper .filter-input::placeholder {
  color: var(--cui-secondary);
  opacity: 0.7;
}
.customer-table-container .filter-panel .filter-field .filter-input-wrapper .filter-clear-btn {
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
  padding: 0;
  width: 20px;
  height: 20px;
  border: none;
  background: none;
  color: var(--cui-secondary);
  z-index: 5;
}
.customer-table-container .filter-panel .filter-field .filter-input-wrapper .filter-clear-btn:hover {
  color: #dc3545;
  background: none;
}
.customer-table-container .no-data-message .loading-message {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--table-text-color);
}
.customer-table-container .no-data-message .no-results-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: var(--cui-secondary);
}
.customer-table-container .no-data-message .no-results-message .btn-link {
  color: var(--filter-focus-color);
  text-decoration: none;
}
.customer-table-container .no-data-message .no-results-message .btn-link:hover {
  text-decoration: underline;
}
.customer-table-container .pagination {
  margin-bottom: 0;
}
.customer-table-container .pagination .page-item .page-link {
  color: var(--table-text-color);
  background-color: var(--table-bg-color);
  border-color: var(--filter-border-color);
}
.customer-table-container .pagination .page-item .page-link:hover {
  color: var(--filter-focus-color);
  background-color: var(--filter-bg-color);
  border-color: var(--filter-focus-color);
}
.customer-table-container .pagination .page-item.active .page-link {
  background-color: var(--filter-focus-color);
  border-color: var(--filter-focus-color);
  color: white;
}
.customer-table-container .pagination .page-item.disabled .page-link {
  color: var(--cui-secondary);
  background-color: var(--table-bg-color);
  border-color: var(--filter-border-color);
}
.customer-table-container .form-select {
  background-color: var(--table-bg-color);
  color: var(--table-text-color);
  border-color: var(--filter-border-color);
}
.customer-table-container .form-select:focus {
  background-color: var(--table-bg-color);
  color: var(--table-text-color);
  border-color: var(--filter-focus-color);
  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);
}
.customer-table-container .form-select option {
  background-color: var(--table-bg-color);
  color: var(--table-text-color);
}
.customer-table-container .cursor-pointer {
  cursor: pointer;
  display: flex;
  justify-content: center;
  transition: all 0.2s ease;
  border-radius: 4px;
}
.customer-table-container .cursor-pointer:hover {
  opacity: 0.8;
  transform: scale(1.1);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}
@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(220, 53, 69, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(220, 53, 69, 0);
  }
}
@media (max-width: 768px) {
  .customer-table-container .filter-panel {
    padding: 1rem;
  }
  .customer-table-container .filter-panel .row {
    --bs-gutter-x: 0.5rem;
  }
  .customer-table-container .filter-panel .filter-field {
    margin-bottom: 1rem;
  }
  .customer-table-container .filter-controls .d-flex {
    flex-direction: column;
    gap: 0.5rem;
    align-items: stretch !important;
  }
  .customer-table-container .filter-controls .d-flex .d-flex {
    flex-direction: row;
    align-items: center !important;
  }
  .customer-table-container .d-flex.justify-content-between.align-items-center.mt-3 {
    flex-direction: column;
    gap: 1rem;
    align-items: stretch !important;
  }
  .customer-table-container .d-flex.justify-content-between.align-items-center.mt-3 .d-flex {
    justify-content: center;
  }
  .customer-table-container .d-flex.justify-content-between.align-items-center.mt-3 .text-muted {
    text-align: center;
  }
}
@media (max-width: 576px) {
  .customer-table-container .filter-panel .col-lg-3, .customer-table-container .filter-panel .col-md-4, .customer-table-container .filter-panel .col-sm-6 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .customer-table-container .filter-panel .filter-field {
    margin-bottom: 0.75rem;
  }
  .customer-table-container .filter-panel .filter-field .filter-label {
    font-size: 0.8rem;
  }
  .customer-table-container .filter-panel .filter-field .filter-input {
    font-size: 0.875rem;
  }
  .customer-table-container .filter-controls .filter-toggle-btn, .customer-table-container .filter-controls .clear-filters-btn {
    font-size: 0.875rem;
    padding: 0.375rem 0.75rem;
  }
  .customer-table-container .filter-controls .results-info {
    font-size: 0.875rem;
    text-align: center;
  }
}
html[data-coreui-theme=dark] .customer-table-container .card {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}
html[data-coreui-theme=dark] .customer-table-container .filter-panel {
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.2);
}
html[data-coreui-theme=dark] .customer-table-container .filter-input:focus {
  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.4);
}
html[data-coreui-theme=dark] .customer-table-container .cursor-pointer:hover {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}
html[data-coreui-theme=dark] .customer-table-container .pagination .page-item .page-link:hover {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}
.customer-table-container * {
  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;
}`, "",{"version":3,"sources":["webpack://./src/components/CustomerTable/CustomerTable.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,sDAAA;EACA,kDAAA;EACA,0BAAA;EACA,8BAAA;EACA,iDAAA;AACF;AACE;EACE,oDAAA;EACA,yDAAA;EACA,+CAAA;EACA,0BAAA;EACA,8BAAA;EACA,iDAAA;AACJ;AAEE;EACE,kDAAA;EACA,gBAAA;AAAJ;AAGE;;;;;;EAME,kDAAA;AADJ;AAGI;;;;;;EACE,kDAAA;AAIN;AAAE;EACE,kDAAA;EACA,uCAAA;EACA,wCAAA;AAEJ;AAAI;EACE,kDAAA;AAEN;AACI;EACE,uCAAA;EACA,8BAAA;AACN;AAKI;EACE,kBAAA;EACA,yBAAA;AAHN;AAKM;EACE,2BAAA;EACA,yCAAA;AAHR;AAMM;EACE,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,4BAAA;AAJR;AAQI;EACE,yBAAA;AANN;AAQM;EACE,cAAA;EACA,qBAAA;AANR;AAWM;EACE,2BAAA;EACA,kBAAA;AATR;AAeE;EACE,wCAAA;EACA,4CAAA;EACA,kBAAA;EACA,eAAA;EACA,+CAAA;AAbJ;AAgBM;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,8BAAA;EACA,qBAAA;AAdR;AAiBM;EACE,kBAAA;AAfR;AAiBQ;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,2BAAA;EACA,UAAA;EACA,oBAAA;AAfV;AAkBQ;EACE,kBAAA;EACA,mBAAA;EACA,4CAAA;EACA,uCAAA;EACA,8BAAA;EACA,yBAAA;AAhBV;AAkBU;EACE,uCAAA;EACA,iDAAA;EACA,uCAAA;EACA,8BAAA;AAhBZ;AAmBU;EACE,2BAAA;EACA,YAAA;AAjBZ;AAqBQ;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,2BAAA;EACA,UAAA;AAnBV;AAqBU;EACE,cAAA;EACA,gBAAA;AAnBZ;AA4BI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;AA1BN;AA6BI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;AA3BN;AA6BM;EACE,gCAAA;EACA,qBAAA;AA3BR;AA6BQ;EACE,0BAAA;AA3BV;AAkCE;EACE,gBAAA;AAhCJ;AAmCM;EACE,8BAAA;EACA,uCAAA;EACA,wCAAA;AAjCR;AAmCQ;EACE,gCAAA;EACA,wCAAA;EACA,uCAAA;AAjCV;AAqCM;EACE,2CAAA;EACA,uCAAA;EACA,YAAA;AAnCR;AAsCM;EACE,2BAAA;EACA,uCAAA;EACA,wCAAA;AApCR;AA0CE;EACE,uCAAA;EACA,8BAAA;EACA,wCAAA;AAxCJ;AA0CI;EACE,uCAAA;EACA,8BAAA;EACA,uCAAA;EACA,iDAAA;AAxCN;AA2CI;EACE,uCAAA;EACA,8BAAA;AAzCN;AA8CE;EACE,eAAA;EACA,aAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;AA5CJ;AA8CI;EACE,YAAA;EACA,qBAAA;EACA,yCAAA;AA5CN;AAiDE;EACE;IACE,0CAAA;EA/CJ;EAiDE;IACE,2CAAA;EA/CJ;EAiDE;IACE,wCAAA;EA/CJ;AACF;AAmDE;EACE;IACE,aAAA;EAjDJ;EAmDI;IACE,qBAAA;EAjDN;EAoDI;IACE,mBAAA;EAlDN;EAuDI;IACE,sBAAA;IACA,WAAA;IACA,+BAAA;EArDN;EAuDM;IACE,mBAAA;IACA,8BAAA;EArDR;EA0DE;IACE,sBAAA;IACA,SAAA;IACA,+BAAA;EAxDJ;EA0DI;IACE,uBAAA;EAxDN;EA2DI;IACE,kBAAA;EAzDN;AACF;AA6DE;EAEI;IACE,cAAA;IACA,eAAA;EA5DN;EA+DI;IACE,sBAAA;EA7DN;EA+DM;IACE,iBAAA;EA7DR;EAgEM;IACE,mBAAA;EA9DR;EAoEI;IACE,mBAAA;IACA,yBAAA;EAlEN;EAqEI;IACE,mBAAA;IACA,kBAAA;EAnEN;AACF;AAyEI;EACE,wCAAA;AAvEN;AA0EI;EACE,8CAAA;AAxEN;AA4EM;EACE,gDAAA;AA1ER;AA8EI;EACE,wCAAA;AA5EN;AAgFM;EACE,wCAAA;AA9ER;AAmFE;EACE,+EAAA;AAjFJ","sourcesContent":[".customer-table-container {\n  --table-bg-color: #fff;\n  --table-border-color: var(--cui-border-color, #d8dbe0);\n  --table-text-color: var(--cui-body-color, #4f5d73);\n  --filter-bg-color: #f8f9fa;\n  --filter-border-color: #dee2e6;\n  --filter-focus-color: var(--cui-primary, #0d6efd);\n  \n  html[data-coreui-theme=\"dark\"] & {\n    --table-bg-color: var(--cui-dark-bg-subtle, #1e1e2f);\n    --table-border-color: var(--cui-dark-border-subtle, #333);\n    --table-text-color: var(--cui-body-color, #fff);\n    --filter-bg-color: #2a2d3a;\n    --filter-border-color: #404552;\n    --filter-focus-color: var(--cui-primary, #0d6efd);\n  }\n\n  .table {\n    border-color: var(--table-border-color) !important;\n    margin-bottom: 0;\n  }\n\n  .table,\n  .table thead,\n  .table tbody,\n  .table tr,\n  .table th,\n  .table td {\n    border-color: var(--table-border-color) !important;\n    \n    &:hover {\n      border-color: var(--table-border-color) !important;\n    }\n  }\n\n  .card {\n    border-color: var(--table-border-color) !important;\n    background-color: var(--table-bg-color);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    \n    &:hover {\n      border-color: var(--table-border-color) !important;\n    }\n    \n    .card-body {\n      background-color: var(--table-bg-color);\n      color: var(--table-text-color);\n    }\n  }\n\n  // Filtre kontrol paneli\n  .filter-controls {\n    .filter-toggle-btn {\n      position: relative;\n      transition: all 0.3s ease;\n      \n      &:hover {\n        transform: translateY(-1px);\n        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n      }\n      \n      .filter-count-badge {\n        background-color: #dc3545;\n        color: white;\n        border-radius: 50%;\n        padding: 2px 6px;\n        font-size: 0.75rem;\n        font-weight: 600;\n        min-width: 18px;\n        text-align: center;\n        display: inline-block;\n        animation: pulse 2s infinite;\n      }\n    }\n    \n    .clear-filters-btn {\n      transition: all 0.2s ease;\n      \n      &:hover {\n        color: #dc3545;\n        border-color: #dc3545;\n      }\n    }\n    \n    .results-info {\n      .filtered-info {\n        color: var(--cui-secondary);\n        font-style: italic;\n      }\n    }\n  }\n\n  // Filtre paneli\n  .filter-panel {\n    background-color: var(--filter-bg-color);\n    border: 1px solid var(--filter-border-color);\n    border-radius: 8px;\n    padding: 1.5rem;\n    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.05);\n    \n    .filter-field {\n      .filter-label {\n        display: block;\n        font-size: 0.875rem;\n        font-weight: 500;\n        color: var(--table-text-color);\n        margin-bottom: 0.5rem;\n      }\n      \n      .filter-input-wrapper {\n        position: relative;\n        \n        .filter-input-icon {\n          position: absolute;\n          left: 10px;\n          top: 50%;\n          transform: translateY(-50%);\n          color: var(--cui-secondary);\n          z-index: 5;\n          pointer-events: none;\n        }\n        \n        .filter-input {\n          padding-left: 35px;\n          padding-right: 35px;\n          border: 1px solid var(--filter-border-color);\n          background-color: var(--table-bg-color);\n          color: var(--table-text-color);\n          transition: all 0.2s ease;\n          \n          &:focus {\n            border-color: var(--filter-focus-color);\n            box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);\n            background-color: var(--table-bg-color);\n            color: var(--table-text-color);\n          }\n          \n          &::placeholder {\n            color: var(--cui-secondary);\n            opacity: 0.7;\n          }\n        }\n        \n        .filter-clear-btn {\n          position: absolute;\n          right: 5px;\n          top: 50%;\n          transform: translateY(-50%);\n          padding: 0;\n          width: 20px;\n          height: 20px;\n          border: none;\n          background: none;\n          color: var(--cui-secondary);\n          z-index: 5;\n          \n          &:hover {\n            color: #dc3545;\n            background: none;\n          }\n        }\n      }\n    }\n  }\n\n  // Veri bulunamadı mesajları\n  .no-data-message {\n    .loading-message {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      color: var(--table-text-color);\n    }\n    \n    .no-results-message {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      color: var(--cui-secondary);\n      \n      .btn-link {\n        color: var(--filter-focus-color);\n        text-decoration: none;\n        \n        &:hover {\n          text-decoration: underline;\n        }\n      }\n    }\n  }\n\n  // Pagination stilleri\n  .pagination {\n    margin-bottom: 0;\n    \n    .page-item {\n      .page-link {\n        color: var(--table-text-color);\n        background-color: var(--table-bg-color);\n        border-color: var(--filter-border-color);\n        \n        &:hover {\n          color: var(--filter-focus-color);\n          background-color: var(--filter-bg-color);\n          border-color: var(--filter-focus-color);\n        }\n      }\n      \n      &.active .page-link {\n        background-color: var(--filter-focus-color);\n        border-color: var(--filter-focus-color);\n        color: white;\n      }\n      \n      &.disabled .page-link {\n        color: var(--cui-secondary);\n        background-color: var(--table-bg-color);\n        border-color: var(--filter-border-color);\n      }\n    }\n  }\n\n  // Form select stilleri\n  .form-select {\n    background-color: var(--table-bg-color);\n    color: var(--table-text-color);\n    border-color: var(--filter-border-color);\n    \n    &:focus {\n      background-color: var(--table-bg-color);\n      color: var(--table-text-color);\n      border-color: var(--filter-focus-color);\n      box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);\n    }\n    \n    option {\n      background-color: var(--table-bg-color);\n      color: var(--table-text-color);\n    }\n  }\n\n  // Action butonları\n  .cursor-pointer {\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    transition: all 0.2s ease;\n    border-radius: 4px;\n    \n    &:hover {\n      opacity: 0.8;\n      transform: scale(1.1);\n      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n    }\n  }\n\n  // Animasyonlar\n  @keyframes pulse {\n    0% {\n      box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.7);\n    }\n    70% {\n      box-shadow: 0 0 0 10px rgba(220, 53, 69, 0);\n    }\n    100% {\n      box-shadow: 0 0 0 0 rgba(220, 53, 69, 0);\n    }\n  }\n\n  // Responsive tasarım\n  @media (max-width: 768px) {\n    .filter-panel {\n      padding: 1rem;\n      \n      .row {\n        --bs-gutter-x: 0.5rem;\n      }\n      \n      .filter-field {\n        margin-bottom: 1rem;\n      }\n    }\n    \n    .filter-controls {\n      .d-flex {\n        flex-direction: column;\n        gap: 0.5rem;\n        align-items: stretch !important;\n        \n        .d-flex {\n          flex-direction: row;\n          align-items: center !important;\n        }\n      }\n    }\n    \n    .d-flex.justify-content-between.align-items-center.mt-3 {\n      flex-direction: column;\n      gap: 1rem;\n      align-items: stretch !important;\n      \n      .d-flex {\n        justify-content: center;\n      }\n      \n      .text-muted {\n        text-align: center;\n      }\n    }\n  }\n\n  @media (max-width: 576px) {\n    .filter-panel {\n      .col-lg-3, .col-md-4, .col-sm-6 {\n        flex: 0 0 100%;\n        max-width: 100%;\n      }\n      \n      .filter-field {\n        margin-bottom: 0.75rem;\n        \n        .filter-label {\n          font-size: 0.8rem;\n        }\n        \n        .filter-input {\n          font-size: 0.875rem;\n        }\n      }\n    }\n    \n    .filter-controls {\n      .filter-toggle-btn, .clear-filters-btn {\n        font-size: 0.875rem;\n        padding: 0.375rem 0.75rem;\n      }\n      \n      .results-info {\n        font-size: 0.875rem;\n        text-align: center;\n      }\n    }\n  }\n\n  // Dark mode özel düzenlemeler\n  html[data-coreui-theme=\"dark\"] & {\n    .card {\n      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n    }\n    \n    .filter-panel {\n      box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.2);\n    }\n    \n    .filter-input {\n      &:focus {\n        box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.4);\n      }\n    }\n    \n    .cursor-pointer:hover {\n      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n    }\n    \n    .pagination .page-item {\n      .page-link:hover {\n        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n      }\n    }\n  }\n\n  * {\n    transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
